export default __webpack_public_path__ + "static/media/right-small.88e5c63a.svg";